<template>
    <div class="vx-col w-full mb-base">
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Swal from 'sweetalert2'

let timerInterval
export default {
    props: {
        createPayroll: {
            type: Object,
            required: false
        },
        isValidate7: {
            type: Boolean,
            required: false
        }
      
    },
    watch: {
        isValidate7(value) {
            if(value)
            this.onConfirmClosePeriod()    
        }
    },
    computed: {
        getAllLogHours() {
            return this.$store.state.payroll.getAllLogHours
        },
        tenantName() {
            return (id) => this.$store.getters['tenants/tenantName'](id)
      },
    },
    methods: {
        onConfirmClosePeriod() {
          Swal.fire({
              title: 'Would you like to close the payroll period ' + moment(this.createPayroll.payOutDate).format('DD MMM YYYY') + '?',
              text: "You will not be able to revert this!",
              icon: 'warning',
              customClass: {
                  icon: "no-before-icon",
              },
              showCancelButton: true,
              confirmButtonColor: '3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Close Period'
            }).then((result) => {
              if (result.isConfirmed) {
                this.$vs.loading()
                this.onOpenWaitingDialog() 
              }
            })
            // this.$confirm('Would you like to close the payroll period ' + moment(this.createPayroll.payOutDate).format('DD MMM YYYY'), 'Confirm?')
            // .then((t) => {
            //     this.$vs.loading()
            //     this.passwordToOpen = t
            //     this.onOpenWaitingDialog() 
            // })
        },
        onOpenWaitingDialog() {
            
            Swal.fire({
                title: 'Closing Payroll Period!',
                html: '<b></b>',
                timer: this.getAllLogHours.length * 1296,
                showConfirmButton: false,
                didOpen: () => {
                    this.onClosePeriod()
                    const b = Swal.getHtmlContainer().querySelector('b')
                    timerInterval = setInterval(() => {
                      if(Swal.getTimerLeft() > 1000 )
                        b.textContent = 'Generating Payslip...'
                      else
                        b.textContent = 'Closing...'
                    }, 100)
                    
                },
                }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === Swal.DismissReason.timer) {
                    
                }
            })
        },
        onClosePeriod() {
        
        var curdate = new Date().toLocaleString()
        let tenant = this.tenantName(this.$store.state.AppActiveUser.tenantsId)

        var logoPath = ''
        var u = 0
        if(tenant.photoId != null) {
          this.$store.dispatch('getFile', tenant.photoId) //Get filePath of Company Logo
            .then((response) => {
              logoPath = response.data.path
              
            })
        }
        //Generate Payslip
        let user = []
        for(var u = 0; u < this.getAllLogHours.length; u++)
        {
          user.push(this.getAllLogHours[u].userId)
        }
        if(user.length  == 0) return
              const data1 = {
                serverName: tenant.secretKey,
                dbName: tenant.apiKey,
                userName: '',
                password: '',
                companyCode: tenant.code,
                companyName: tenant.name,
                address: tenant.address,
                photoURL: logoPath,
                createPayrollId: this.createPayroll.createPayrollId,
                printedBy: this.$store.state.AppActiveUser.uid,
                reportName:['PayrollPayslip'],
                payOutDate: moment(this.createPayroll.payOutDate).format('YYYYMMDD'),
                creditDate: moment(this.createPayroll.payOutDate).format('YYYYMMDD'),
                passwordToOpen: null,
                monthName: '',
                yearScope: '',
                reportType: 'CURRENT',
                userId:  user
              }
  
              
              this.$store.dispatch('payroll/GenerateReports', data1)//PRINTING PAYSLIP
                .then((response) => {
                  if(response.status === 200) {
                    console.log("DONE PAYSLIP")
                        const data = {
                          payrollId: this.createPayroll.createPayrollId,
                          dateClosed: curdate,
                          processedBy: this.$store.state.AppActiveUser.uid
                          }
                        this.$store.dispatch('payroll/ClosedPayroll', data)
                          .then((res) => {
                            this.$vs.loading.close()
                            if(res.status === 200) {

                              Swal.fire({ title: 'Done', 
                                  html: 'Payroll cut-off ' + this.createPayroll.cutOffStartDate + ' to ' + this.createPayroll.cutOffEndDate + ' has been closed', 
                                  icon:'success', 
                                  timer: 2000, 
                                  timerProgressBar: true,
                                  didOpen: () => {
                                      this.$router.go()
                                  },})
                                
               
                            }
                          })
                          .catch((err) => {
                            this.$vs.loading.close()
                            console.log(err)
                          })
                      
                  }
                })
                .catch((err) => {
                    this.$vs.loading.close()
                    console.log(err)
                })

              
        
        //Closed Payroll
         
    },
    
  },
  components: {
        Swal,
    }
}
</script>